import { all, fork } from "redux-saga/effects";

//public
import AuthSaga from "./auth/login/saga";
import ProfileSaga from "./auth/profile/saga";
import LayoutSaga from "./layout/saga";
import roleSaga from "./Role/saga"
import rolePermissionSaga from "./RolePermission/saga"
import addressSaga from "./Address/saga";
import entitySaga from "./Entity/saga";
import userSaga from "./User/saga";

import permissionSaga from "./permission/saga";
import templateSaga from "./Template/saga";
import SMStemplateSaga from "./SMSTemplate/saga";
import NotificationtemplateSaga from "./notificationTemplate/saga";
import ApiConfigurationSaga from "./Configuration/ApiConfiguration/saga";
import SystemConfigurationSaga from "./Configuration/SystemConfiguration/saga";

export default function* rootSaga() {
  yield all([
    //public
    fork(AuthSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(rolePermissionSaga),
    fork(addressSaga),
    fork(entitySaga),
    fork(userSaga),
    fork(roleSaga),
    fork(permissionSaga),
    fork(templateSaga),
    fork(SMStemplateSaga),
    fork(NotificationtemplateSaga),
    fork(ApiConfigurationSaga),
    fork(SystemConfigurationSaga),
  ]);
}
